import { HStack } from "@chakra-ui/react"
import { XIcon } from "@pathwright/pathicons"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import InteractiveTooltip from "../shared/InteractiveTooltip"
import ShareDropdown from "../shared/ShareDropdown"
import { useSelectPeopleContext } from "./SelectPeopleContext"
import SelectRoleDescriptorsDrawerOption from "./SelectRoleDescriptorsDrawerOption"
import { getRoleLabel } from "./utils"
import { isInviteRoleGated, isInviteRoleVisible } from "../shared/rolesConfig"

const tPrefix = "share_card.add_tab"

// Empty array value prevents the Select from internally selecting any option.
// Does mean we're using the Select purely as a Menu here.
const emptyValue = []

const SelectRole = () => {
  const {
    rolePermissions,
    permissions,
    peopleSelection: { selected },
    removeFromPeopleSelection,
    updateRoleSelection
  } = useSelectPeopleContext()
  const { t, tc, tca } = useTranslate()

  const roleOptions = Object.keys(rolePermissions).reduce((acc, key) => {
    const invite = rolePermissions[key]
    if (!isInviteRoleVisible(invite)) return acc

    acc.push({
      value: key,
      label: getRoleLabel("verb", key, tca),
      disabled: isInviteRoleGated(invite)
    })

    return acc
  }, [])

  const clearSelectionOption = {
    label: tc(`${tPrefix}.Clear selection`),
    value: "__clear_selection",
    render: (node) => (
      <HStack color="gray.500">
        <XIcon size={"1.2em"} />
        {node}
      </HStack>
    )
  }

  return (
    <SelectRoleDescriptorsDrawerOption>
      {({ option: drawerOption, onOpen }) => {
        const handleChange = (value) => {
          switch (value) {
            case drawerOption.value:
              onOpen()
              break
            case clearSelectionOption.value:
              removeFromPeopleSelection(selected)
              break
            default:
              updateRoleSelection(selected, value)
          }
        }

        return (
          <ShareDropdown
            name="role"
            label={`${tc(`${tPrefix}.Update all`)}...`}
            value={emptyValue}
            options={[...roleOptions, clearSelectionOption, drawerOption]}
            onChange={handleChange}
          />
        )
      }}
    </SelectRoleDescriptorsDrawerOption>
  )
}

export default SelectRole
